import { render } from "./Home2.vue?vue&type=template&id=c60b39c6&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"

import "./Home2.vue?vue&type=style&index=0&id=c60b39c6&lang=scss&scoped=true"
import "./Home2.vue?vue&type=style&index=1&id=c60b39c6&lang=scss"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60b39c6"]])

export default __exports__